import {BUSINESS_NAME} from "@/content";

export type ParallaxContent = {
    title: string;
    subTitle: string;
    overline: string;
    imageUrl: string;
    buttonCTA: string;
    tint: string;
    align: 'left' | 'right' | 'center';
    buttonLink: string;
};

export const parallaxContent1: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Expert Excavation for Sydney Homes',
    subTitle:'Tight-access mini digs, pool demolition and footpath excavation for Sydney properties.',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-1.jpg',
    buttonCTA:'Get Your Free Site Quote Today',
    align:'left',
    tint:'rgba(0, 0, 0, 0.3)',
    buttonLink:undefined, //define this in the page
}

export const parallaxContent2: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Commercial Excavation Solutions Sydney',
    subTitle:'Trusted by builders and developers, we provide bulk excavation, site cuts, underground basements and industrial footings with the right equipment for challenging conditions.',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-2.jpg',
    buttonCTA:'Request a Commercial Excavation Estimate',
    tint:'rgba(0, 0, 0, 0.3)',
    align:'right',
    buttonLink:undefined, //define this in the page
}

